<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="stageDialogVisible" :title="'选择'+$titles.stage" width="600px" :close-on-click-modal="false"
      :close-on-press-escape="false" @closed="close">
      <div style="margin:10px 0px;display: flex;justify-content: space-between;">
        <el-input v-model="searchValue" :placeholder="'输入'+$titles.stage+'名称/编号搜索'" size="small" @keyup.enter.native="search" />
      </div>
      <el-table
        ref="multipleTable"
        :data="searchList"
        tooltip-effect="dark"
        style="width: 100%;min-height:200px; overflow-y: auto;"
        height="calc(100% - 50px)"
        border
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="49" align="center" />
        <el-table-column prop="stageName" :label="$titles.stage+'名称'" align="left" />
        <el-table-column prop="templateStageId" :label="$titles.stage+'编号'" align="left" />
      </el-table>
      <div class="addTitle">
        没有要选择的{{ $titles.stage }}？
        <el-button v-if="!showAddingForm" type="text" size="small" @click="showAddingForm = true">+新增{{ $titles.stage }}</el-button>
        <el-button v-if="showAddingForm" type="text" icon="el-icon-check" size="small" @click="handleAddStage">提交</el-button>
        <el-button v-if="showAddingForm" type="text" icon="el-icon-close" size="small" @click="close">
          取消
        </el-button>
      </div>
      <el-form v-if="showAddingForm" ref="addingForm" :model="addingForm" label-position="left" label-width="80px" size="small">
        <el-form-item :label="$titles.stage+'名称'" :rules="{ required: true, message: ' ' }">
          <el-input v-model="addingForm.stageName" placeholder="必填" maxlength="30" :show-word-limit="true" size="small"></el-input>
        </el-form-item>
        <el-form-item v-model="addingForm.stageCode" :label="$titles.stage+'编号'">
          <el-input v-model="addingForm.stageCode" placeholder="选填，不填时系统自动编号" maxlength="10"
            :show-word-limit="true" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="!showAddingForm" size="small" @click="stageDialogVisible = false">取 消</el-button>
        <el-button v-if="!showAddingForm" v-preventReClick size="small" type="primary" @click="submit('stage', 1)">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import service from "@/CommonDP/service/folder-service";
import { notBlank } from "@/CommonDP/utils/validate";
import folderService from "@/CommonDP/service/folder-service";
export default {
  props: {
    first: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Object,
      required: false,
      default: () => {}
    },
    data: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      stageDialogVisible: false,
      selectionData: [],
      stageList: [],
      showAddingForm: false,
      addingForm: {
        stageName: "",
        stageCode: ""
      },
      searchValue: '',
      searchList: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    filteredStageList() {
      // 过滤已添加的数据
      if (!this.stageDialogVisible) return [];
      const childrenList = this.treeData.childrenList;
      return this.stageList.filter((item) => {
        if (this.first) {
          return !this.data.map((d) => d.typeId).includes(item.stageId);
        } else {
          return !childrenList?.map((d) => d.typeId).includes(item.stageId);
        }
      });
    }

  },
  watch: {
    searchValue(newValue) {
      if (!newValue) {
        this.searchList = this.filteredStageList;
      }
    }
  },
  methods: {
    show() {
      this.searchValue = "";
      this.searchList = [];
      this.selectionData = [];
      this.stageList = [];
      this.stageDialogVisible = true;
      this.queryStageList();
    },
    queryStageList() {
      const params = { enterpriseId: this.enterpriseId };
      service.queryStageList(params).then((res) => {
        this.stageList = res.data;
        this.search();
      });
    },
    submit(type, val) {
      if (!this.selectionData || !this.selectionData.length) {
        this.$error("至少勾选一条记录");
        return;
      }
      const data = { type, val, selectionData: this.selectionData, parentNodeData: this.treeData };
      this.$emit("callback", data);
      this.stageDialogVisible = false;
    },
    handleSelectionChange(val) {
      this.selectionData = val;
    },

    async handleAddStage() {
      await this.$refs.addingForm.validate();
      const success = notBlank(this.addingForm.stageName, this.$titles.stage + "名称不能为空");
      if (!success) {
        return;
      }
      const stageName = this.filteredStageList.some(ele => ele.stageName === this.addingForm.stageName);
      if (stageName) {
        this.$error(this.$titles.stage + "名称已存在");
        return;
      }
      const stageCode = this.filteredStageList.some(ele => ele.templateStageId === this.addingForm.stageCode);
      if (stageCode) {
        this.$error(this.$titles.stage + "编号已存在");
        return;
      }
      this.addingForm.enterpriseId = this.enterpriseId;
      await folderService.addEnterpriseStage(this.addingForm);
      await this.queryStageList();
      this.showAddingForm = false;
      this.$success("已添加" + this.$titles.stage + "：" + this.addingForm.stageName + "，请从列表中选择");
    },
    search() {
      const { searchValue: name } = this;
      setTimeout(() => {
        this.searchList = this.filteredStageList.filter((item) => this.filterKeyword(item, name));
      }, 500);
    },
    filterKeyword(item, name) {
      const keyArr = ["stageName", "templateStageId"];
      let flag = false;
      while (keyArr[0] && !flag) {
        if (item[keyArr.shift()].includes(name)) flag = true;
      }
      return flag;
    },
    // 关闭事件
    close(){
      this.addingForm = {
        stageName: "",
        stageCode: ""
      };
      this.showAddingForm = false;
    }
  }
};
</script>

<style scoped lang="scss">
.addTitle {
  font-size: 1.1em;
  font-weight: bold;
}
</style>
